module.exports = __webpack_public_path__ + "static/img/1082_big.9f498fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1082_big.png
// module id = 8qVO
// module chunks = 1